// services/api.js
const API_URL = process.env.REACT_APP_API_URL;

// ==================== SERVICIOS PÚBLICOS ====================

export const serviciosAPI = {
  buscar: (origen, destino, fecha) => 
    fetch(`${API_URL}/servicios/buscar?origen=${encodeURIComponent(origen || '')}&destino=${encodeURIComponent(destino || '')}&fecha=${fecha || ''}`)
      .then(res => {
        if (!res.ok) throw new Error('Error al buscar servicios');
        return res.json();
      }),
  
  getFechasDisponibles: (origen, destino) => 
    fetch(`${API_URL}/servicios/fechas-disponibles?origen=${encodeURIComponent(origen || '')}&destino=${encodeURIComponent(destino || '')}`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar fechas');
        return res.json();
      }),
  
  getCiudades: () => 
    fetch(`${API_URL}/servicios/ciudades`)
      .then(res => res.json()),
  
  crearReserva: (datosReserva) => {
    // ✅ Asegurar que tramoIds se envíe si existe
    const payload = {
      servicioId: datosReserva.servicioId,
      cantidadPasajeros: datosReserva.cantidadPasajeros,
      nombresPasajeros: datosReserva.nombresPasajeros || [],
      cedulaTitular: datosReserva.cedulaTitular || '',
      cedulasPasajeros: datosReserva.cedulasPasajeros || [],
      nombrePasajero: datosReserva.nombrePasajero,
      emailPasajero: datosReserva.emailPasajero || '',
      telefonoPasajero: datosReserva.telefonoPasajero,
      telefonoParticular: datosReserva.telefonoParticular || '',
      metodoPago: datosReserva.metodoPago || 'Efectivo',
      comprobante: datosReserva.comprobante || null,
      tramoIds: datosReserva.tramoIds || [] // ✅ NUEVO: enviar tramos seleccionados
    };
    
    return fetch(`${API_URL}/servicios/reservas`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw err });
      return res.json();
    });
  },
  
  confirmarReserva: (reservaId) => 
    fetch(`${API_URL}/servicios/reservas/${reservaId}/confirmar`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' }
    }).then(res => {
      if (!res.ok) throw new Error('Error al confirmar reserva');
      return res.json();
    }),
  
  liberarReserva: (reservaId) => 
    fetch(`${API_URL}/servicios/reservas/${reservaId}/liberar`, {
      method: 'DELETE'
    }).then(res => {
      if (!res.ok) throw new Error('Error al liberar reserva');
      return res.json();
    }),
  
  getMetodosPagoByServicio: (servicioId) => 
    fetch(`${API_URL}/servicios/${servicioId}/metodos-pago`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar métodos de pago');
        return res.json();
      })
};

// ==================== ADMIN ====================

export const adminAPI = {
  // Servicios
  listar: () => 
    fetch(`${API_URL}/admin/servicios`)
      .then(res => res.json()),
  
  obtener: (id) => 
    fetch(`${API_URL}/admin/servicios/${id}`)
      .then(res => res.json()),
  
  crear: (servicio) => 
    fetch(`${API_URL}/admin/servicios`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(servicio)
    }).then(res => res.json()),
  
  actualizar: (id, servicio) => 
    fetch(`${API_URL}/admin/servicios/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(servicio)
    }).then(res => res.json()),
  
  eliminar: (id) => 
    fetch(`${API_URL}/admin/servicios/${id}`, {
      method: 'DELETE'
    }).then(res => res.json()),
  
  asignarMetodosPago: (servicioId, metodoPagoIds) => 
    fetch(`${API_URL}/admin/servicios/${servicioId}/metodos-pago`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(metodoPagoIds)
    }).then(res => {
      if (!res.ok) throw new Error('Error al asignar métodos de pago');
      return res.json();
    }),
  
  getMetodosPagoAsignados: (servicioId) => 
    fetch(`${API_URL}/admin/servicios/${servicioId}/metodos-pago`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar métodos asignados');
        return res.json();
      }),
  
  // Reservas
  listarReservas: () => 
    fetch(`${API_URL}/admin/reservas`)
      .then(res => res.json()),
  
  obtenerReserva: (id) => 
    fetch(`${API_URL}/admin/reservas/${id}`)
      .then(res => res.json()),
  
  buscarReserva: (ticket, email) => {
    const params = new URLSearchParams();
    if (ticket) params.append('ticket', ticket);
    if (email) params.append('email', email);
    return fetch(`${API_URL}/admin/reservas/buscar?${params}`)
      .then(res => res.json());
  },
  
  buscarReservaPorCedula: (cedula) => 
    fetch(`${API_URL}/admin/reservas/buscar-por-cedula?cedula=${encodeURIComponent(cedula)}`)
      .then(res => {
        if (res.status === 404) {
          return { notFound: true };
        }
        if (!res.ok) throw new Error('Error al buscar reserva');
        return res.json();
      }),
  
  confirmarPago: (id) => 
    fetch(`${API_URL}/admin/reservas/${id}/confirmar-pago`, {
      method: 'PUT'
    }).then(res => res.json()),
  
  cancelarReserva: (id) => 
    fetch(`${API_URL}/admin/reservas/${id}/cancelar`, {
      method: 'PUT'
    }).then(res => res.json()),
  
  ventaDirecta: (data) => 
    fetch(`${API_URL}/admin/reservas/directa`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(res => res.json()),
  
  getEstadisticas: () => 
    fetch(`${API_URL}/admin/estadisticas`)
      .then(res => res.json())
};

// ==================== MÉTODOS DE PAGO ====================

export const metodosPagoAPI = {
  getAll: () => 
    fetch(`${API_URL}/metodospago`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar métodos de pago');
        return res.json();
      }),
  
  getActivos: () => 
    fetch(`${API_URL}/metodospago/activos`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar métodos activos');
        return res.json();
      }),
  
  getById: (id) => 
    fetch(`${API_URL}/metodospago/${id}`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar método');
        return res.json();
      }),
  
  create: (data) => 
    fetch(`${API_URL}/metodospago`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw err });
      return res.json();
    }),
  
  update: (id, data) => 
    fetch(`${API_URL}/metodospago/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw err });
      return res.json();
    }),
  
  delete: (id) => 
    fetch(`${API_URL}/metodospago/${id}`, {
      method: 'DELETE'
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw err });
      return res.json();
    }),
  
  getCuentas: () => 
    fetch(`${API_URL}/metodospago/cuentas`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar cuentas');
        return res.json();
      }),
  
  getCuentaById: (id) => 
    fetch(`${API_URL}/metodospago/cuentas/${id}`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar cuenta');
        return res.json();
      }),
  
  createCuenta: (data) => 
    fetch(`${API_URL}/metodospago/cuentas`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw err });
      return res.json();
    }),
  
  updateCuenta: (id, data) => 
    fetch(`${API_URL}/metodospago/cuentas/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw err });
      return res.json();
    }),
  
  deleteCuenta: (id) => 
    fetch(`${API_URL}/metodospago/cuentas/${id}`, {
      method: 'DELETE'
    }).then(res => {
      if (!res.ok) return res.json().then(err => { throw err });
      return res.json();
    })
};